import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@material-ui/core/styles';
import { Tabs, Tab, Typography } from '@material-ui/core';
import { FormArea, LoginArea, LoginBox, Logo, Root, StyledTab, TitleIntranet } from './style';
import { FormLogin } from '../common/Forms/FormLogin';
import { FormFirstAcess } from '../common/Forms/FormFirstAcess';

import logo from '../../assets/img/msv_intranet_logo_login.png';

const Login = ({ history }) => {
  const theme = useTheme();

  const [value, setValue] = useState(0);
  const [firstAcess, setFirstAcess] = useState(false);

  const { isLogged } = useSelector(({ auth }) => ({
    isLogged: auth?.isAuthenticated || false,
  }));

  useEffect(() => {
    if (isLogged) history.push('/home');
  }, [isLogged]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <Root>
      <LoginArea>
        <Logo>
          <img src={logo} alt="Logo ManServ" />
        </Logo>
        <LoginBox>
          <StyledTab position="static" color="default">
            <Tabs value={value} onChange={handleChange} indicatorColor="primary" textColor="primary" variant="fullWidth">
              <Tab label={firstAcess ? 'Primeiro acesso' : 'Login'} />
            </Tabs>
          </StyledTab>
          <SwipeableViews axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'} index={value} onChangeIndex={handleChangeIndex}>
            <FormArea index={0}>{firstAcess ? <FormFirstAcess setFirstAcess={setFirstAcess} /> : <FormLogin setFirstAcess={setFirstAcess} />}</FormArea>
          </SwipeableViews>
        </LoginBox>
      </LoginArea>
    </Root>
  );
};

export default Login;
